import React, { FC } from 'react';

type PropsT = {
  fill?: string;
};

const ShrinkIconBold: FC<PropsT> = ({ fill }) => (
  <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M1.67862 10.1445L0.235796 8.7017L6.32706 2.6044H1.75107L1.76314 0.636363H9.73793V8.61719H7.75781L7.76989 4.04723L1.67862 10.1445Z" fill={fill || "#909090"} />
  </svg>
);

export default ShrinkIconBold;
import React, { FC } from 'react';

type PropsT = {
  fill?: string;
};

const ShrinkIconBold: FC<PropsT> = ({ fill }) => (
  <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M1.67862 10.1445L0.235796 8.7017L6.32706 2.6044H1.75107L1.76314 0.636363H9.73793V8.61719H7.75781L7.76989 4.04723L1.67862 10.1445Z" fill={fill || "#909090"} />
  </svg>
);

export default ShrinkIconBold;
